import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter,numberFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator'
import { getAccounts,getBusinessEntities,getUsersCountByAccount } from "../../crud/auth.crud";
import {
  Portlet,
  PortletBody,
} from "../../partials/content/Portlet";
import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import EditIcon from '@material-ui/icons/Edit';
 import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
 import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
 import { Link } from "react-router-dom";

export default class Account extends React.Component {

  defaultSorted = [{
    dataField: 'accountName',
    order: 'desc'
  }];

  columns = [
  
    {
      dataField: 'accountName',
      text: 'Name',
      width: 150,
      sort: true,
      filter: textFilter(),
        sortCaret: (order, column) => {
        if (!order) return (<span></span>);
        else if (order === 'asc') return (<span>&nbsp;&nbsp;<ArrowUpwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        else if (order === 'desc') return (<span>&nbsp;&nbsp;<ArrowDownwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        return null;
      }
    },
    {
      dataField: 'businessEntity',
      text: 'Business Type',
      sort:true,
      sortCaret: (order, column) => {
        if (!order) return (<span></span>);
        else if (order === 'asc') return (<span>&nbsp;&nbsp;<ArrowUpwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        else if (order === 'desc') return (<span>&nbsp;&nbsp;<ArrowDownwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        return null;
      }
    },
    {
      dataField:'storageUtilized',
      text: 'Storage Utilized',
      sort:true,
      sortCaret: (order, column) => {
        if (!order) return (<span></span>);
        else if (order === 'asc') return (<span>&nbsp;&nbsp;<ArrowUpwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        else if (order === 'desc') return (<span>&nbsp;&nbsp;<ArrowDownwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        return null;
      }
    },
    {
      dataField:'usersUtilized',
      text: 'Users Utilized',
      sort:true,
      sortCaret: (order, column) => {
        if (!order) return (<span></span>);
        else if (order === 'asc') return (<span>&nbsp;&nbsp;<ArrowUpwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        else if (order === 'desc') return (<span>&nbsp;&nbsp;<ArrowDownwardIcon style={{ color: '#5578eb',fontSize: 15}}/></span>);
        return null;
      }
     
    },
    {
      dataField: 'df0',
      isDummyField: true,
      sort:false,
      text: 'Add Locations',
      formatter: (cellContent, row) => {
       
          return (
            <Link  to={{pathname:"/addlocation", data: {account:row}}}>
                           <Tooltip
                                    title="Add Locations" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
          );
       
      }
    },
    {
      dataField: 'df1',
      isDummyField: true,
      sort:false,
      text: 'Edit',
      formatter: (cellContent, row) => {
       
          return (
            <Link  to={{pathname:"/editaccount", data: {account:row}}}>
                           <Tooltip
                                    title="Edit Account" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
          );
       
      }
    },
  ];

  state = {
    accounts:[],
    allAccounts:[],
    businessEntities:[],
    columns :this.columns,
    defaultSorted: this.defaultSorted,
  }

  filterAccounts=(type)=>
  {
    let tempAccounts=[];
    let accounts=this.state.allAccounts;
      if(type!="all")
      {
      accounts.filter(acc=> acc.businessEntity==type).map((acc1)=>(

          tempAccounts.push(acc1)
        ))      
      this.setState({ accounts: tempAccounts})
    }
    else
      this.setState({ accounts: accounts})
  }
  componentDidMount()
  {
    if(this.props.location.data!=null)
    {
    getAccounts().then(response => response.data)
    .then(async (data) => {
      let tempAccounts=[];
      let accdata= data;
     await getUsersCountByAccount().then(res => res.data)
      .then((resdata) => {
        //console.log(resdata);
        resdata.map((acc)=>{
          let index = accdata.findIndex(x=> x.accountId===acc.accountKey);
          //console.log("index:::",index);
          accdata[index] = {...accdata[index], usersUtilized:acc.total};
        });
        
      });

      accdata.filter(acc=> acc.businessEntity==this.props.location.data).map((acc1)=>(

          tempAccounts.push(acc1)
        ))      
      this.setState({ accounts: tempAccounts,allAccounts:accdata })
      //console.log(this.state.users)
     })
  }
  else
  {
    getAccounts().then(response => response.data)
    .then(async (data) => {
      let accdata= data;
     await getUsersCountByAccount().then(res => res.data)
      .then((resdata) => {
        console.log(resdata);
        if (resdata!==undefined && resdata!==null && resdata!==""){
           resdata.map((acc)=>{
          let index = accdata.findIndex(x=> x.accountId===acc.accountKey);
          //console.log("index:::",index);
          accdata[index] = {...accdata[index], usersUtilized:acc.total};
        });
      }
      
        
      });

       
      this.setState({ accounts: accdata,allAccounts:accdata })
      //this.setState({ accounts: data,allAccounts:data })
      //console.log(this.state.users)
     })
  }
    getBusinessEntities().then(response => response.data)
    .then((data) => {
      this.setState({ businessEntities: data })
      //alert('Business found:'+data.length)
      //console.log('Business : ',data)
     })
  }
  render() {
    return (
      <>

         <div className="row">
        
        <div className="col-xl-12">
          <div className="row">
           {this.state.businessEntities.map((entity) => (
            <div className="col-lg-3">
              <Link onClick={()=>this.filterAccounts(entity.description)}>
                <Portlet className="kt-portlet--border-bottom-brand">
                  <PortletBody fluid={true}>
                    <div className="kt-widget26">
                      <div className="kt-widget26__content">
                        <span className="kt-widget26__number" > 
                          {this.state.allAccounts.filter(acc=> acc.businessEntity==entity.description).length}
                        </span>
                        <span className="kt-widget26__desc">{entity.description}</span>
                      </div>
                    </div>
                  </PortletBody>
                </Portlet>
              </Link>
             </div>
            ))}
            <div className="col-lg-3">
              <Link onClick={()=>this.filterAccounts("all")}>
                <Portlet className="kt-portlet--border-bottom-brand">
                  <PortletBody fluid={true}>
                    <div className="kt-widget26">
                      <div className="kt-widget26__content">
                        <span className="kt-widget26__number" > 
                          {this.state.allAccounts.length} 
                        </span>
                        <span className="kt-widget26__desc">Total Accounts</span>
                      </div>
                    </div>
                  </PortletBody>
                </Portlet>
              </Link>
             </div>
          </div>
        </div>
        
        
      </div>

        <div className="row">
          <div className="col-md-12">
          <Grid beforeCodeTitle="Accounts" jsCode="true" createPath="/createaccount">
              <div className="kt-section">
            <BootstrapTable
              bootstrap4
              keyField="accountKey"
              data={ this.state.accounts }
              columns={ this.state.columns }
              defaultSorted={ this.state.defaultSorted } 
              filter={ filterFactory() }
              pagination={ paginationFactory()}
              paginationSize={100}
            />
           </div>
           </Grid>
            {/*<Grid beforeCodeTitle="Accounts" jsCode="true" createPath="/createaccount">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      
                      <th>Name</th>
                      <th>Business Type</th>
                                         <th>Storage Utilized</th>
                      <th>Users Utilized</th>
                      <th>Locations</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.accounts.map((account) => (
                    <tr>
                     
                      <td>{account.accountName}</td>
                      <td>{account.businessEntity}</td>
                  
                      <td>{account.storageUtilized!=null? Math.round(account.storageUtilized/1024/1024/1024,2):'0.0'} {' '}GB</td>
                      <td>{account.usersUtilized!=null? account.usersUtilized: 0}</td>
                      <td>
                         
                          <Link  to={{pathname:"/addlocation", data: {account:account}}}>
                          Add / View
                          </Link>
                          
                      </td>

                      <td>
                         
                          <Link  to={{pathname:"/editaccount", data: {account:account}}}>
                           <Tooltip
                                    title="Edit Account" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
                  */}
          </div>
         
        </div>

      

       
      </>
    );
  }
}
